import axios from 'axios';
import store from "@/config/stores"

// 环境的切换

let app_id = process.env.VUE_APP_APP_ID || "app_wt"
let version_code = "1.0.1"
axios.defaults.baseURL = process.env.VUE_APP_API_BASE_URL || '/api';

// 超时时间
axios.defaults.timeout = 30000;
axios.defaults.withCredentials = true;

export function get(url, params) {
  if (!params) {
    params = {}
  }
  params.app_id = app_id
  if (window.navigator.standalone) {
    params.app_type = "webapp"
  }
  params.version_code = version_code
  let lineStr = store.getters.getLineId

  if (lineStr) {
    params.line = parseInt(lineStr)
  } else {
    params.line = 0
  }
  return new Promise((resolve, reject) => {
    axios
        .get(url, {
          params: params
        })
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
  });
}

export function post(url, params, config) {
  if (!params) {
    params = {}
  }
  params.app_id = app_id

  let postParams = {
    "app_id": app_id,
    "version_code": version_code,
  }

  if (window.navigator.standalone) {
    params.app_type = "webapp"
    postParams.app_type = "webapp"
  }

  let lineStr = store.getters.getLineId
  if (lineStr) {
    params.line = parseInt(lineStr)
    postParams.line = parseInt(lineStr)
  } else {
    params.line = 0
    postParams.line = 0
  }

  let configPost = {
    params: postParams,
  }

  if (config) {
    for (let k in config) {
      if (config.hasOwnProperty(k)) {
        configPost[k] = config[k];
      }
    }
  }

  return new Promise((resolve, reject) => {
    axios
        .post(url, params, configPost)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err.data);
        });
  });
}
